'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePage = exports.createPage = exports.fetchPageDonationCount = exports.fetchPage = exports.fetchPages = exports.deserializePage = undefined;

var _client = require('../../utils/client');

var _everydayhero = require('./everydayhero');

var _justgiving = require('./justgiving');

/**
 * @function deserializer for fundraising pages
 */
var deserializePage = exports.deserializePage = function deserializePage(page) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.deserializePage)(page) : (0, _everydayhero.deserializePage)(page);
};

/**
 * @function fetches multiple pages
 */
var fetchPages = exports.fetchPages = function fetchPages(params) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.fetchPages)(params) : (0, _everydayhero.fetchPages)(params);
};

/**
 * @function fetches a single page
 */
var fetchPage = exports.fetchPage = function fetchPage(page) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.fetchPage)(page) : (0, _everydayhero.fetchPage)(page);
};

/**
 * @function fetches a page's donation count
 */
var fetchPageDonationCount = exports.fetchPageDonationCount = function fetchPageDonationCount(page) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.fetchPageDonationCount)(page) : (0, _everydayhero.fetchPageDonationCount)(page);
};

/**
 * @function create page
 */
var createPage = exports.createPage = function createPage(params) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.createPage)(params) : (0, _everydayhero.createPage)(params);
};

/**
 * @function update page
 */
var updatePage = exports.updatePage = function updatePage(pageId, params) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.updatePage)(pageId, params) : (0, _everydayhero.updatePage)(pageId, params);
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/pages/index.js
// module id = 61
// module chunks = 0